import {
  FAILED_GET_COMPANY,
  FAILED_PERSIST_COMPANY,
  RECEIVE_GET_COMPANY,
  RECEIVE_GET_COMPANIES,
  RECEIVE_PERSIST_COMPANY,
  REQUEST_PERSIST_COMPANY,
} from 'redux/actions/company'
import {RESET_STATE} from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_COMPANY:
    case FAILED_PERSIST_COMPANY:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        }
      }
    case RECEIVE_PERSIST_COMPANY:
    case RECEIVE_GET_COMPANY:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        }
      }
    case RECEIVE_GET_COMPANIES:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        }
      }
    case REQUEST_PERSIST_COMPANY:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true
        }
      }
    case RESET_STATE:
      if (action.state === 'company') {
        return {
          ...state,
          [action.screen]: initialState[action.screen]
        }
      }
    default:
      return state
  }
}
